import ProvidersList from './ProvidersList';

export default function Telepsicologia() {
    return (
        <ProvidersList
            type="telepsicologia"
            title="Telepsicologia"
            subtitle="Benefícios de telepsicologia dos assinantes."
        />
    );
}
